module.exports = __webpack_public_path__ + "img/b0dbb21.png";